import { useState } from 'react'

const InputCard = ({
    id,
    field,
    label = '',
    type = 'text',
    placeholder = '',
    value,
    isRequired = true,
    isReadOnly,
    onChange,
    mask,
    pattern,
    title,
    onlyInput = false,
    cssClassStyle = '',
    useToolTip = false,
    textToolTip = '',
    titleToolTip = '',
    useIconSearch = false,
    onClickIconSeach,
    maxValue = undefined,
    prefix = '',
    useIcon = false,
    Icon
}: IPropsInput) => {

    let timer: any;
    const [card, setCard] = useState({ value: '', maskedValue: '' });

    const setFormat = (input: any) => [...input]
        .map((x, i) => (i + 1) % 4 == 0 && i > 0 && x != ' ' ? `${x} ` : x == ' ' ? '' : x)
        .join('');

    const setMask = (input: any) => (show: any) => [...input]
        .map((x, i, e) => i > 3 && i < 14 && x != ' ' && (i != (e.length - 1) || show) ? '*' : x)
        .join('').trim();

    const waiter = () => {

        clearTimeout(timer);


        timer = setTimeout(() => {
            setCard(prev => {
                let v = setFormat(prev.value);
                v = setMask(v)(true);

                return { ...prev, maskedValue: v }
            });
        }, 600);
    };

    const onInput = (e: any) => {

        let c = e.nativeEvent.data;

        if (e.nativeEvent.inputType === 'insertFromPaste') {
            let value = e.nativeEvent.target.value;
            let m = setFormat(value);
            m = setMask(m)(true);
            setCard({ ...card, value: value, maskedValue: m });
            onChange( field, value );
        }
        else if (c == null) {
            setCard({ value: '', maskedValue: '' });
            onChange( field, '' );
        } else {
            let v = `${card.value}${c}`;
            setCard({ ...card, value: v, maskedValue: `${card.maskedValue}${c}` });
            onChange( field, v );
        }
        waiter();

        // 
    }

    const cssInput = `input-field-auto-cr ${cssClassStyle}`;
    return (
        <div className="lbl-input-auto-cr mt-10 mb-5">
            {!onlyInput && <div className="lbl-input-auto-cr mt-10 mb-5" style={{ display: "flex" }}>
                <span> {label} {isRequired && <span style={{ color: '#4D4D4D' }}>*</span>} </span>

            </div>}
            <div className={`mb-10`}>
                <input
                    id={id}
                    name={field}
                    type={type}
                    placeholder={placeholder}
                    value={card.maskedValue}
                    required={isRequired}
                    onChange={onInput}
                    readOnly={isReadOnly}
                    autoComplete='off'
                    title='Campo requerido'
                    maxLength={19}
                    className={cssInput}
                />
            </div>

        </div>

    )
}

export { InputCard }